// react
import { FC, memo, useState } from 'react';

// types
import { TimeSlotWrapperProps } from './TimeSlotWrapper.types';

// utils
import { DAY_AVAILABILITIES } from 'components/mrp/components/AppointmentForm/AppointmentForm.consts';
import { isEqual } from 'lodash';

// components
import { Box } from '@mui/material';

const TIME_GUTTER_CLASS = '.rbc-time-gutter';
const TIME_SLOT_CLASS = '.rbc-timeslot-group';

const TimeSlotWrapper: FC<TimeSlotWrapperProps> = memo(
  ({ children, value, calendarId, resource }) => {
    const [timeSlotRef, setTimeSlotRef] = useState<HTMLDivElement | null>(null);

    const isGutterCell = !!timeSlotRef?.closest(TIME_GUTTER_CLASS);

    if (!!resource) {
      const parent = timeSlotRef?.closest(TIME_SLOT_CLASS);
      const column = parent?.parentElement?.parentElement;
      column?.classList.add(`time-column-${resource}`);
      column?.parentElement?.classList.add('resource-bundle');
    }

    if (isGutterCell || resource === DAY_AVAILABILITIES) {
      return <Box ref={setTimeSlotRef}>{children}</Box>;
    }

    return (
      <Box
        className="time-slot-cell-container"
        ref={setTimeSlotRef}
        data-calendar-id={calendarId}
        data-time-stamp={value.toISOString()}
      >
        <Box className="time-slot-cell" />
      </Box>
    );
  },
  (prev, next) => {
    return isEqual(prev.value, next.value);
  }
);

export default TimeSlotWrapper;
